export enum RolesActionDispatchTypes {
  GET_ROLES_INVOKE = "GET_ROLES_INVOKE",
  GET_ROLES_SUCCESS = "GET_ROLES_SUCCESS",
}
